import { stringify } from "qs";
import fetchClient from "api/client";
import PARENT_COMPANIES_ENDPOINT from "api/parentCompanies/parentCompaniesEndpoint";
import getPerPageQueryParam from "helpers/getPerPageQueryParam";

/**
 * @description GET api/parent-companies/list
 * @param {Object} context - https://tanstack.com/query/v4/docs/react/guides/query-functions#queryfunctioncontext
 * @param {["parent-companies-list", GetParentCompaniesListQueryParams]} context.queryKey
 * @param {AbortSignal} context.signal
 *
 * @return {Promise<GetParentCompaniesListResponse|Error>}
 * */
export default function getParentCompaniesList({
  queryKey: [, { page, perPage, ...queryParams }],
  signal,
}) {
  const queryString = stringify(
    {
      ...queryParams,
      page: page || 0,
      ...getPerPageQueryParam(perPage),
    },
    { addQueryPrefix: true },
  );

  return fetchClient.get(`${PARENT_COMPANIES_ENDPOINT}/list/${queryString}`, { signal });
}

/**
 * @typedef {Object} GetParentCompaniesListQueryParams
 * @property {number} [page]
 * @property {number} perPage
 * @property {string} [search]
 * @property {'id' | 'name' | 'totalProspects'} [sortBy]
 * @property {'asc' | 'desc'} [sortDir]
 * */

/**
 * @typedef {Object} GetParentCompaniesListResponse
 * @property {Array<Company>} data
 * @property {number} total
 * */

/**
 * @typedef {Object} Company
 * @property {number | string} id
 * @property {string} name
 * */
